import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Pages
import Login from './pages/Login';
import Testimonial from './pages/Dashboard/Testimonial';
import ContentEdit from './pages/Dashboard/ContentEdit';
import Portfolio from './pages/Dashboard/Portfolio';
import Logs from './pages/Dashboard/logs/Logs';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/dashboard/testimonial" element={<Testimonial />} />
        <Route path="/dashboard/content" element={<ContentEdit />} />
        <Route path="/dashboard/portfolio" element={<Portfolio />} />
        <Route path="/dashboard/logs" element={<Logs />} />
      </Routes>
    </Router>
  );
}

export default App;
